
















import Vue from 'vue'
export default Vue.extend({
  name: 'warn-page',
  props: {
    type: {
      type: String,
      default: 'warn'
    }
  }
})
